import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { manageConfiguration } from "../../../data/configuration";
import { useAuth } from "../../../providers/auth";

function SidebarWrapper({
  options,
  headerSection: HeaderSection,
  children,
}: {
  options: any;
  headerSection?: any;
  children: any;
}) {
  const [newConfig, setNewConfig] = useState(false);
  const [newEmpConfig, setNewEMPConfig] = useState(false);
  const [archiveOpen, setArchiveOpen] = useState(false);

  const { role } = useAuth();
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const data = await manageConfiguration();
        if (data[0]?.manage_new_ui) {
          setNewConfig(data[0]?.manage_new_ui);
          setNewEMPConfig(data[0]?.manage_new_ui_employer);
        }
      } finally { }
    };
    fetchSkills();
  }, []);

  const activeStyle =
    "bg-instant-teams-teal-Main text-white border-l-4 border-0 border-green-400 text-left pl-4  block w-screen py-2 cursor-pointer";
  const inActiveStyle =
    "text-left  hover:bg-instant-teams-teal-Main w-full pl-4 hover:border-l-4 hover:border-green-400 block w-screen py-2 cursor-pointer";

  // Separate archive and non-archive items
  const archiveItems = options.filter((pageObj: any) => pageObj.id !== "User Academy");
  const userAcademyItem = options.find((pageObj: any) => pageObj.id === "User Academy");

  return (
    <>
      <div className={`absolute left-0 min-h-screen overflow-hidden`}>
        <div
          id="tabmenu"
          className="bg-instant-teams-blue-Main text-white font-medium pt-8 pb-36 w-1/6 h-screen fixed overflow-auto no-scrollbar shadow-black shadow-inner"
        >
          <div className="sticky pt-36 bg-instant-teams-blue-Main ">
            {HeaderSection && <HeaderSection />}
          </div>
          <div>
            {/* Archive Dropdown */}

            {/* User Academy (not in Archive) */}
            {archiveItems.map((pageObj: any) =>
              pageObj.viewer !== undefined &&
                pageObj.viewer.includes(role.id) &&
                pageObj.menuDisplay ? (
                <NavLink
                  id={pageObj.id}
                  key={pageObj.id}
                  to={pageObj.path}
                  className={({ isActive }: { isActive: boolean }) =>
                    isActive ? activeStyle : inActiveStyle
                  }
                >
                  {pageObj.name}
                </NavLink>
              ) : null
            )}

            <div className="w-full">
              {userAcademyItem && <button
                className="w-full flex text-left pl-4 py-2 cursor-pointer items-center"
                onClick={() => setArchiveOpen((prev: any) => !prev)}
              >
                Archived
                <svg
                  className={`ml-2 h-4 w-4 transition-transform ${archiveOpen ? "rotate-180" : ""}`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>}
              {archiveOpen && (
                <div className="ml-4">

                  {userAcademyItem &&
                    userAcademyItem.viewer !== undefined &&
                    userAcademyItem.viewer.includes(role.id) &&
                    userAcademyItem.menuDisplay && (
                      <div className="w-full">
                        <NavLink
                          id={userAcademyItem.id}
                          key={userAcademyItem.id}
                          to={userAcademyItem.path}
                          className={({ isActive }: { isActive: boolean }) =>
                            isActive ? activeStyle : inActiveStyle
                          }
                        >
                          {userAcademyItem.name}
                        </NavLink>
                      </div>
                    )}

                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`flex-1 ml-[20%] pt-36 pr-10"} `}>{children}</div>
    </>
  );
}

export default SidebarWrapper;
